import { wrapTextChildrenWithTypography } from '@/helpers/typography-wrapper'
import TopNavigationBarItem from '@/scopes/common/components/Header/TopNavigationBarItem'
import * as NavigationMenu from '@radix-ui/react-navigation-menu'
import { NavigationMenuTriggerProps } from '@radix-ui/react-navigation-menu'
import { tok } from '@sunwebgroup/ui-components'
import { focusOutline, Icon } from '@sunwebgroup/ui-components/uds'
import { PropsWithChildren } from 'react'
import { styled } from 'styled-components'

const NavigationTrigger = styled(NavigationMenu.Trigger).attrs(({ ...rest }) => ({
  asChild: true,
  ...rest,
}))`
  &[data-state='open'] {
    background: ${tok('primitives_color_neutral_100')};

    ${Icon} {
      transform: rotate(180deg);
    }
  }

  &[data-state] + div {
    display: none;
  }

  ${focusOutline()}
`

function Trigger({ children, ...rest }: PropsWithChildren<NavigationMenuTriggerProps>) {
  return (
    <NavigationTrigger asChild {...rest}>
      <TopNavigationBarItem>
        {wrapTextChildrenWithTypography(children)}
      </TopNavigationBarItem>
    </NavigationTrigger>
  )
}

export const MenuTrigger = styled(Trigger)``
